import { Action } from 'redux';

import { ApplicationActionTypes } from './applicationActionTypes';

export interface IResetApplication extends Action<typeof ApplicationActionTypes.RESET> { }

export type ApplicationActions = IResetApplication;

export const actionCreators = {
    resetApplication(): IResetApplication {
        return {
            type: ApplicationActionTypes.RESET
        };
    }
};

export const resetApplication = () => (actionCreators.resetApplication());